import { createFileRoute } from '@tanstack/react-router'
import DocumentosDigitaisAssinaturasPage from '@/pages/dashboard/documentos-digitais-assinaturas-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/assinaturas/',
)({
  component: DocumentosDigitaisAssinaturasPage,
})
